<template>
  <div>
    <div class="my-list">
      <!-- <div class="my-list-item flex-b" @click="clearLocationFg">
        <div class="item-left flex">
          <div>退出登录</div>
        </div>
        <div class="item-right flex">
          <span class="iconfont iconarrow-right-bold" style="size: 22px; color: #999"></span>
        </div>
      </div>-->
    </div>
  </div>
</template>
<script>
import { Dialog, Toast } from 'vant'
export default {
  data() {
    return {}
  },
  mounted() {
    this.prohibitweixinShare()
  },
  methods: {
    clearLocationFg() {
      Dialog.confirm({
        message: '确认退出当前登录账号吗？',
      })
        .then(() => {
          localStorage.clear('token')
          // sessionStorage.clear()
          Toast('退出登录成功')
          setTimeout(() => {
            this.$router.push({ path: './home' })
          }, 100)
        })
        .catch(() => {
          // on cancel
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.my-list {
  margin: 20px auto 0;
  box-sizing: border-box;
  border-bottom: 1px solid #eeeeee;
  padding: 0 40px;
  background: #ffffff;
  .my-list-item {
    padding: 20px 0;
    .item-left {
      font-size: 28px;
      font-weight: 500;
      color: #333333;
      line-height: 60px;
      img {
        width: 60px;
        height: 60px;
        display: block;
        margin-right: 20px;
      }
    }
    .item-right {
      font-size: 28px;
      font-weight: 500;
      color: #999999;
      line-height: 60px;
      margin-right: 20px;
    }
  }
  .my-list-item + .my-list-item {
    border-top: 1px solid #f0f0f0;
  }
}
</style>